import { takeLatest } from 'redux-saga/effects'
import { FETCH_CHAT_DATA_SAGA } from 'src/store/types/chatData'
import fetchChatData from './fetchChatData'

export function* chatDataSaga() {
  yield takeLatest(FETCH_CHAT_DATA_SAGA, fetchChatData)
}
